/**
 * Firebase Configuration and Initialization
 *
 * This module initializes Firebase with your project credentials
 * and exports auth and analytics instances for use throughout the app.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);

// Initialize Firebase Analytics (only in browser environments that support it)
let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
    console.log('Firebase Analytics initialized');
  }
}).catch((err) => {
  console.warn('Firebase Analytics not supported:', err);
});

/**
 * Log a custom event to Firebase Analytics
 * @param {string} eventName - Name of the event
 * @param {Object} eventParams - Optional parameters for the event
 */
export const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

/**
 * Log a page view to Firebase Analytics
 * @param {string} pageName - Name of the page
 * @param {string} pagePath - Path of the page
 */
export const logPageView = (pageName, pagePath) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_title: pageName,
      page_path: pagePath,
    });
  }
};

export { analytics };
export default app;
